import { weekday, isPublicHoliday } from "@sundial/core";

/**
 * Returns true if the given date is a weekend or (when frHolidaysEnabled)
 * a French public holiday. Pure display helper — does not check DB entries.
 */
export function isOffDay(date: string, frHolidaysEnabled: boolean): boolean {
  const wd = weekday(date); // 0=Sunday, 6=Saturday
  if (wd === 0 || wd === 6) return true;
  if (frHolidaysEnabled && isPublicHoliday(date)) return true;
  return false;
}
